import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { RESOURCE_LINK_BASE_ROUTES } from './resource-link-base.routes';

export const RESOURCE_LINKS_RESOURCE_LINK_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...RESOURCE_LINK_BASE_ROUTES];
    routesService.add(routes);
  };
}
